import { Injectable } from '@angular/core';
import localeEnUS from '@angular/common/locales/en';
import localeFrCH from '@angular/common/locales/fr-CH';
import localeItCH from '@angular/common/locales/it-CH';

import { environment } from '../environments/environment';

import { Lang } from "./common/providers/langs-provider";

@Injectable({
  providedIn: 'root'
})
export class ConfigProvider {
    public prodMode: boolean;
    public platformName = 'Elitment';
    public isRegistrationDisabled = true;
    public elitmentOrganizationId: number;


    public apiRootUrl: string;
    public storageRootUrl: string;
    public appUrl: string;
    public apiPasswordGrantClient: number;
    public apiPasswordGrantSecret: string;
    public facebookPageUrl: string;
    public assetsUrl = '/assets/res_13/';
    public homepageRedirect?: string;
    public defaultKeyValueStore = 'memory';

    public availableLangs: Lang[] = [
      { id: 1, name: 'English', shortName: 'EN', code: 'en', dateLocale: 'en-US', angularLocale: localeEnUS },
      { id: 2, name: 'Français', shortName: 'FR', code: 'fr-CH', dateLocale: 'fr-CH', angularLocale: localeFrCH },
      // { id: 3, name: 'Deutsch', shortName: 'DE', code: 'de', dateLocale: 'de-DE' },
      { id: 4, name: 'Italien', shortName: 'IT', code: 'it-CH', dateLocale: 'it-CH', angularLocale: localeItCH },
    ];

    public defaultLang: Lang = this.availableLangs[0];

    constructor(
    ) {
        this.prodMode = environment.production;
        this.apiRootUrl = environment.apiRootUrl;
        this.storageRootUrl = environment.storageRootUrl;
        this.appUrl = environment.appUrl;
        this.apiPasswordGrantClient = environment.apiPasswordGrantClient;
        this.apiPasswordGrantSecret = environment.apiPasswordGrantSecret;
        this.facebookPageUrl = environment.facebookPageUrl;
        this.homepageRedirect = environment.homepageRedirect;
        this.elitmentOrganizationId = environment.elitmentOrganizationId;
    }
}
